export default {
    // 模块名称
  deviceAccess: {
    // 按钮类
    button: {            
      reset: 'Reset',
      query: 'Query',
      save: 'Save',
      cancel: 'Cancel',
      confirm: 'Confirm',
      close: 'Close',
      view: 'Details',
      addsystem: 'Add System',
      edit: 'Edit',
      uninstall: 'Uninstall',
      back: 'Back',
      sync: 'Sync',
      delete: 'Delete',
      devlist: 'Device list',
      update: 'Update list',
      eventconf: 'Config',
      modify: 'Modify',
      batchDeletion: 'Batch Deletion'
    },
    // 文字标签类
    label: {
      analyse: 'Video analytics platform',
      manage: 'Access platform',
      accessControl: 'Face access',
      alarm: 'Alarm host',
      firefighting: 'Fire fighting',
      camera: 'Camera',
      no: 'No',
      event: 'Original event/alarm',
      handle: 'Handle method',
      eventname: 'Event name',
      level: 'Alarm level',
      systemname: 'System name',
      systemstatus: 'System status',
      ip: 'IP',
      port: 'Port',
      account: 'Account',
      password: 'Password',
      vcn: 'VCN',
      plugins: 'Plugin',
      factory: 'Manufacturer',
      platname: 'Platform name',
      version: 'Version',
      os: 'OS',
      protocol: 'Protocol',
      connection: 'Connection',
      platform: 'Platform',          
      straightthrough: 'Straight',          
      controlcenter: 'Control center',
      domain: 'Domain code',
      deivcename: 'Deivce name',
      deviceid: 'Deivce ID',
      deivceip: 'Deivce IP',
      subdevicetype: 'Subdevice type',
      deivcecode: 'Camera code',
      cameraname: 'Camera name',
      parentcode: 'Parent code',            
      cameratype: 'Camera type',
      location: 'Location',
      network: 'Network Type',
      status: 'Device status',
      volice: 'Enable audio',
      supportanalyse: 'Intelligent analysis',
      creattime: 'Creation time',
      nvr: 'NVR code',
      exdomain: 'External domain',
      cameradev: 'Camera device',
      langdev: 'Language device',
      alarmdev: 'Alarm device',            
      maintype: 'Master type',
      area: 'Area',
      offline: 'Offline',
      online: 'Online',
      sleep: 'Sleep',
      disabled: 'Disabled',
      enabled: 'Enabled',
      no2: 'NO',
      yes: 'Yes',
      nosupport: 'No support',
      support: 'Support',
      secretkey: 'Secretkey',
      doorname: 'Door name',
      devicemodel: 'Model',
      doorid: 'Door ID',
      relaystatus: 'Relay status',
      devicetype: 'Device type',
      subSystem: 'Subsystem',
      grade: 'Grade',
      alarmType: 'Alarm type',
    },
    // 提示类
    placeholder: {
      select: 'Select',
      deivcename: 'Enter device name',
      deviceid: 'Enter device id',
      doorname: 'Enter door name'
    },
    // 消息类
    message: {
        editSuccess: 'Edit successfully',
        editFailed: 'Edit failed',
        nospace: 'System name cannot contain spaces',
        ipformat: 'IP format is incorrect',
        systemname: 'Enter system name',
        less50: '1 to 50 characters in length',
        less200: '1 to 200 characters in length',
        ip: 'Enter ip',
        port: 'Enter port',
        port2: 'Enter correct port',
        account: 'Enter account',
        password: 'Enter password',
        vcn: 'Select vcn',
        uninstall: 'Are you sure to uninstall the system?',
        numberchar: 'Only enter numbers and letters',
        onlynumber: 'Only enter numbers',
        plugins: 'Select a plugin',
        domain: 'Enter domain code',
        deltips: 'Please select the device you want to delete',
        deltips2: 'Are you sure to delete the device?',
        delsuccess: 'Delete successfully',
        delfail: 'Delete failed',
        secretkey: 'Enter a secret key',
        nodata: 'No data',
        type: 'Alarm type cannot be empty',
    },
    // 标题类
    title: {            
      warn: 'Warning',
      uninstall: 'Uninstall',
      devdetails: 'Device details',
      devdelete: 'Delete device'
    }
  }
}
